module.exports = __webpack_public_path__ + "img/KY.763ddfd9.svg";